<template>
    <div class="m-user clearfix">
        <span class="user-name"><em v-if="$store.state.userinfo.areaId">【{{ $queryArea($store.state.userinfo.areaId) }}】</em>你好，{{ $store.state.userinfo.name || $store.state.ua.account || '仙术师' }}</span>
        <span class="area-name">
            <em v-if="!$store.state.userinfo.areaId && parseInt($store.state.login)" class="u-btn bind-area" @click="$bind_modal()">【绑定大区】</em>       
        </span>

        <div class="user-ctrl f-r">
            <em v-if="$store.state.userinfo.areaId && $store.state.login" class="u-btn bind-area" @click="$bind_modal()">【切换大区】</em>
            <span class="u-btn login" v-if="login == 0" @click="$mslogin.open()">【登录】</span>       
            <span class="u-btn logout" v-else @click="logout">【退出】</span>            
        </div>
    </div>    
</template>

<style scoped>
.area-name{
    vertical-align: top;    
}
</style>

<script>
export default {
    name : 'm-user',
    data (){
        return {
            ua : {},
            userinfo : {},
            login : 0,
        }
    },
    created (){
        this.ua = this.$store.state.ua || {}
        this.userinfo = this.$store.state.userinfo || {}
        this.login = this.$store.state.login
    },
    methods : {
        logout (){
            var _this = this;
            localStorage.clear();
            setTimeout(function () { 
                //TODO   
                document.location = _this.$global.domain;
            }, 100);            
        },
        twoJsonMerge(json1,json2){
            var length1 = 0,length2 = 0,jsonStr,str;
            for(var ever in json1) length1++;
            for(var ever in json2) length2++; 
            if(length1 && length2)str = ',';
            else str = '';
            jsonStr = ((JSON.stringify(json1)).replace(/,}/,'}') + (JSON.stringify(json2)).replace(/,}/,'}')).replace(/}{/,str);
            return JSON.parse(jsonStr);
        },      
    }
}
</script>


// WEBPACK FOOTER //
// src/components/userinfo.vue